// See: https://blog.mgechev.com/2015/02/06/parsing-binary-protocol-data-javascript-typedarrays-blobs/#:~:text=The%20two%20possible%20values%20for,is%20the%20blob%20binary%20type.

import { TextEncoder, TextDecoder } from 'text-encoding-shim'
import { assert } from '../lib/assert-sidecar'
import { l } from './lodash'
const ten = new TextEncoder('utf-8')
const tdec = new TextDecoder('utf-8')
const maxStringLength = 256
export interface IMessageWriter {
  sv: string
  buffer: ArrayBuffer
  dataView: DataView
  offset: number // in bytes
  isText: boolean
}

const defaultIsTextMode = false
export function create(
  isText: boolean = defaultIsTextMode,
  buff: ArrayBuffer | null = null,
): IMessageWriter {
  if (!buff) {
    buff = new ArrayBuffer(1024)
  }
  let dv = new DataView(buff)
  let obj: IMessageWriter = {
    sv: '',
    buffer: buff,
    dataView: dv,
    offset: 0,
    isText,
  }

  return obj
}

export function writeHeader(m: IMessageWriter, toMultiId: number) {
  //write16(m, toMultiId)

  write8Unsigned(m, toMultiId & 0xff)
  write8Unsigned(m, (toMultiId >> 8) & 0xff)

  // console.log(
  //   'write header',
  //   toMultiId,
  //   toMultiId & 0xff,
  //   (toMultiId >> 8) & 0xff,
  // )
}

export function write8(m: IMessageWriter, v: number) {
  v = Math.floor(v)
  assert.assertIsByte(v)
  if (m.isText) {
    m.sv += v + '|'
    // console.log('test m.sv', m.sv)
  } else {
    m.dataView.setInt8(m.offset, v)
    m.offset++
  }
}

export function write8Unsigned(m: IMessageWriter, v: number) {
  v = Math.floor(v)
  assert.assertIsByteUnsigned(v)
  if (m.isText) {
    m.sv += v + '|'
    // console.log('test m.sv', m.sv)
  } else {
    m.dataView.setInt8(m.offset, v)
    m.offset++
  }
}

export function read8(m: IMessageWriter): number {
  if (m.isText) {
    let idx = m.sv.indexOf('|', m.offset + 1)
    let v = parseInt(m.sv.substring(m.offset, idx))
    // console.log('test m.sv r', idx, m.sv.substring(m.offset, idx), v)
    m.offset = idx + 1

    return v
  } else {
    let v = m.dataView.getInt8(m.offset)
    m.offset++
    return v
  }
}
export function readU8(m: IMessageWriter): number {
  if (m.isText) {
    let idx = m.sv.indexOf('|', m.offset + 1)
    let v = parseInt(m.sv.substring(m.offset, idx))
    m.offset = idx + 1
    return v
  } else {
    let v = m.dataView.getUint8(m.offset)
    m.offset++
    return v
  }
}
export function writeBool(m: IMessageWriter, v: boolean) {
  if (m.isText) {
    m.sv += (v ? 't' : 'f') + '|'
  } else {
    m.dataView.setInt8(m.offset, v ? 1 : 0)
    m.offset++
  }
}

export function readBool(m: IMessageWriter): boolean {
  if (m.isText) {
    let idx = m.sv.indexOf('|', m.offset + 1)
    let v = m.sv.substring(m.offset, idx) === 't'
    m.offset = idx + 1
    return v
  } else {
    let v = m.dataView.getInt8(m.offset)
    m.offset++
    return v === 1
  }
}

export function peek8(m: IMessageWriter): number {
  if (m.isText) {
    let idx = m.sv.indexOf('|', m.offset + 1)
    let v = parseInt(m.sv.substring(m.offset, idx))
    return v
  } else {
    let v = m.dataView.getInt8(m.offset)
    return v
  }
}

export function write16(m: IMessageWriter, v: number) {
  v = Math.floor(v)
  assert.assertIsInt16(v)
  if (m.isText) {
    m.sv += v + '|'
  } else {
    m.dataView.setInt16(m.offset, v, false)
    m.offset += 2
  }
}

export function read16(m: IMessageWriter): number {
  if (m.isText) {
    let idx = m.sv.indexOf('|', m.offset + 1)
    let v = parseInt(m.sv.substring(m.offset, idx))
    // console.log('test m.sv r', idx, m.sv.substring(m.offset, idx), v)
    m.offset = idx + 1
    return v
  } else {
    let v = m.dataView.getInt16(m.offset, false)
    m.offset += 2
    return v
  }
}

export function write32(m: IMessageWriter, v: number) {
  v = Math.floor(v)
  // assert.assertIsInt16(v)
  if (m.isText) {
    m.sv += v + '|'
  } else {
    m.dataView.setInt32(m.offset, v, false)
    m.offset += 4
  }
}

export function read32(m: IMessageWriter): number {
  if (m.isText) {
    let idx = m.sv.indexOf('|', m.offset + 1)
    let v = parseInt(m.sv.substring(m.offset, idx))
    m.offset = idx + 1
    return v
  } else {
    let v = m.dataView.getInt32(m.offset, false)
    m.offset += 4
    return v
  }
}

export function writeFloat(m: IMessageWriter, v: number) {
  if (m.isText) {
    m.sv += v + '|'
  } else {
    m.dataView.setFloat32(m.offset, v, false)
    m.offset += 4
  }
}

export function readFloat(m: IMessageWriter): number {
  if (m.isText) {
    let idx = m.sv.indexOf('|', m.offset + 1)
    let v = parseFloat(m.sv.substring(m.offset, idx))
    m.offset = idx + 1
    return v
  } else {
    let v = m.dataView.getFloat32(m.offset, false)
    m.offset += 4
    return v
  }
}

export function writeString(m: IMessageWriter, v: string) {
  v = v || ''
  if (m.isText) {
    m.sv += v + '|'
  } else {
    let encoded: Uint8Array = ten.encode(v)
    let len = encoded.length
    if (len > maxStringLength) {
      len = maxStringLength
    }
    write16(m, len)
    if (len) {
      for (let i = 0; i < len; i++) {
        m.dataView.setUint8(m.offset + i, encoded[i])
      }
      m.offset += len
    }
  }
}

export function readString(m: IMessageWriter) {
  if (m.isText) {
    let idx = m.sv.indexOf('|', m.offset + 1)
    let v = m.sv.substring(m.offset, idx)
    m.offset = idx + 1
    return v
  } else {
    let len = read16(m)
    if (!len) {
      return ''
    }
    let buff = m.buffer.slice(m.offset, m.offset + len)
    let decoded: string = tdec.decode(new DataView(buff))
    // console.log('decoded string', decoded)
    m.offset += len
    return decoded
  }
}

export function rewind(m: IMessageWriter) {
  m.offset = 0
}

export function test<T>(
  msg: string,
  data: T,
  write: (m: IMessageWriter, d: T) => void,
  read: (m: IMessageWriter) => T,
) {
  let tf = [true, false]
  l.forEach(tf, (c) => {
    let m = create(c)
    write(m, data)
    rewind(m)
    let data2 = read(m)
    assert.deepEqSlow(data, data2, 'test message', msg)
  })
}
